<script setup lang="ts">
import { Search } from 'lucide-vue-next'

defineProps<{
  placeholder: string
}>()

const model = defineModel<string>({ required: true })
</script>

<template>
  <div class="relative w-full sm:w-64">
    <Search class="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground" />
    <Input
      v-model="model"
      type="search"
      class="pl-10"
      :placeholder="placeholder"
      :aria-label="placeholder"
      data-testid="list-search"
    />
  </div>
</template>
